export function createId(...props) {
    return props
        .map(String)
        .map((prop) => prop
        .toLowerCase()
        .replace(/[^0-9a-z\-]/g, '')
        .replace(/\s+/g, '-'))
        .join('-');
}
